<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
     class="d-flex flex-column w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row background-light-gray border-bottom border-dark-subtle p-3 m-0 z-max d-flex align-items-center height-details-header">
        <div (click)="back()"
             class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2"
             type="button">
            <i class="fa-solid fa-chevron-left color-secondary-information m-auto"></i>
        </div>
        <div class="col-2 m-0 d-flex justify-content-center">
            <app-gateway-svg [status]="status()"
                             [online]=true
                             class="img-fluid img-max m-0"></app-gateway-svg>
        </div>
        @if (!loading) {
            <div class="col-8 m-0">
                <div class="fw-bold">Alter {{ gateway()?.name || '-' }}</div>
            </div>
        }
        <div (click)="close()"
             class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2"
             type="button">
            <i class="fa-solid fa-x color-secondary-information m-auto"></i>
        </div>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar gap-3">
        <div>
            <div class="row">
                <div class="col">Name</div>
            </div>
            <div class="row">
                <div class="col">
                    <input (input)="setName($event)"
                            [disabled]="loading || !canBeAltered"
                            class="form-control"
                            id="name"
                            placeholder="Name"
                            required
                            type="text"
                            value="{{gateway()?.name }}">
                </div>
            </div>
        </div>

        <div>
            <div class="row">
                <div class="col">Latitude</div>
                <div class="col">Longitude</div>
            </div>
            <div class="row">
                <div class="col">
                    <input (input)="setLatitude($event)"
                           [disabled]="loading || !canBeAltered"
                           class="form-control"
                           datatype="text"
                           id="latitude"
                           name="latitude"
                           placeholder="Latitude"
                           type="number"
                           value="{{gateway()?.location?.coords![0] || 'Latitude'}}">
                </div>
                <div class="col">
                    <input (input)="setLongitude($event)"
                           [disabled]="loading || !canBeAltered"
                           class="form-control"
                           datatype="text"
                           id="longitude"
                           name="longitude"
                           placeholder="Longitude"
                           type="number"
                           value="{{gateway()?.location?.coords![1] || 'Longitude'}}">
                </div>
            </div>
        </div>

        <app-generic-button
            (click)="onDropAPin()"
            description="Drop a pin for gateway"
            [alwaysShowText]="true"
            [buttonText]="'Drop a pin'"
            [disabled]="loading || !canBeAltered"
            [loading]="loading"
            [primaryIcon]="'fa-solid fa-pin'"/>

        <app-generic-button
            (click)="applyChanges()"
            description="Save changes to gateway"
            [alwaysShowText]="true"
            [buttonText]="'Apply changes'"
            [disabled]="loading || !canBeAltered"
            [loading]="loading"
            [primaryIcon]="'fa-solid fa-check'"/>
    </div>
</div>